import { DashboardStaffs, DashboardState, TicketsData, Todo } from '@/types/Dashboard';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: DashboardState = {
  ticketsData: null,
  dashboardStaffs: {
    staffData: null,
    staffSearchText: '',
    filterValue: 0,
    staffSortKey: 'first_name',
    staffSortDirection: 'desc',
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setTicketsData(state, action: PayloadAction<TicketsData | null>) {
      state.ticketsData = action.payload;
    },
    addTodoToState(state, action: PayloadAction<Todo>) {
      if (state.ticketsData) {
        state.ticketsData.todo.push(action.payload);
      }
    },
    deleteTodoFromState(state, action: PayloadAction<{ column: string; id: string }>) {
      const { column, id: todoId } = action.payload;
      if (state.ticketsData?.[column]) {
        state.ticketsData[column] = state.ticketsData[column].filter(todo => todo.id !== todoId);
      }
    },
    updateTodoInState(state, action: PayloadAction<{ column: string; id: string; todo: Partial<Todo> }>) {
      const { column, id, todo: updates } = action.payload;
      if (state.ticketsData?.[column]) {
        state.ticketsData[column] = state.ticketsData[column].map(todo => (todo.id === id ? { ...todo, ...updates } : todo));
      }
    },
    setDashboardStaffAction(state, action: PayloadAction<DashboardStaffs>) {
      state.dashboardStaffs = action.payload;
    },
    setDashboardStaffSortAction: (state, action: PayloadAction<{ sortKey: string; sortDirection: 'asc' | 'desc' }>) => {
      state.dashboardStaffs.staffSortKey = action.payload.sortKey;
      state.dashboardStaffs.staffSortDirection = action.payload.sortDirection;
    },
    setDashboardStaffSearchTextAction: (state, action: PayloadAction<string>) => {
      state.dashboardStaffs.staffSearchText = action.payload;
    },
    setDashboardStaffFilterValueAction(state, action: PayloadAction<number>) {
      state.dashboardStaffs.filterValue = action.payload;
    },
    clearDashboardStateAction: () => initialState,
  },
});

export const {
  setTicketsData,
  addTodoToState,
  deleteTodoFromState,
  updateTodoInState,
  setDashboardStaffAction,
  setDashboardStaffSearchTextAction,
  setDashboardStaffFilterValueAction,
  clearDashboardStateAction,
  setDashboardStaffSortAction,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
